import React, { useState } from 'react'
import EquationEditor from "./TextArea"
import axios from 'axios';
import Swal from 'sweetalert2'
import { QuestionTypes } from '../constants';
import QuestionIcon from "../assets/Question.png";
import { useParams } from 'react-router-dom';
import { BASE_URL } from "../constants";


export default function OpenEndedQuestion({
  questions,
  setIsPlaying,
  setQuestions,
  setHitQuestion,
  setFullStyle,
  videoRef,
  editMode,
  currentTimeInSec,
  isOpenEndedQuestionVisiable,
  setIsOpenEndedQuestionVisiable,
  question = { questionBody: "" }
}) {
  console.log(currentTimeInSec);

  const { id } = useParams();
  const [questionBody, setQuestionBody] = useState(question.questionBody);
  const handleCloseInnerModal = () => {
    setIsOpenEndedQuestionVisiable(!isOpenEndedQuestionVisiable);
  }

  const sweetAlert = ({ title, text, icon }) => {
    return Swal.fire({
      title: `${title}`,
      text: `${text}`,
      icon: `${icon}`
    });
  }

  const updateQuestions = (id) => {
    const editedQuestions = questions.filter((q) => q.id !== id).concat([
      {
        id: question.id,
        questionBody: questionBody,
        type: parseInt(QuestionTypes.essay),
        time: Math.floor(currentTimeInSec),
        options: [],
      }])
    setQuestions(editedQuestions);
  }

  const addQuestions = (id) => {
    setQuestions((prevQuestions) => [...prevQuestions, {
      id: id,
      questionBody: questionBody,
      type: parseInt(QuestionTypes.essay),
      time: Math.floor(currentTimeInSec),
      options: [],
    }])
  }

  const formatResponse = () => {
    const formattedResponse = {
      question_body: questionBody,
      question_type: parseInt(QuestionTypes.essay),
      timestamp: Math.floor(currentTimeInSec)
    }
    if (editMode) {
      updateQuestions(question.id)
    }
    return formattedResponse;
  }

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const formattedResponse = formatResponse();
    if (editMode) {
      axios.put(`${BASE_URL}/lesson/updateQuestion.php?lessonId=${id}&questionId=${question.id}`, formattedResponse)
        .then((res) => {
          sweetAlert({ title: "Good job!", text: res.data.msg, icon: "success" });
          const video = videoRef.current;
          handleCloseInnerModal();
          setHitQuestion(false);
          setIsPlaying(true);
          video.id == "video" && video.play();
        })
    } else {
      axios.post(`${BASE_URL}/lesson/addQuestion.php?lessonId=${id}`, formattedResponse).then((res) => {
        sweetAlert({ title: "Good job!", text: res.data.message, icon: "success" });
        if (res.data.id) {
          addQuestions(res.data.id)

        }
        handleCloseInnerModal();

      }).catch(err => {
        console.log(err);
      })
    }
  };


  return (
    <form className='question-overlay-center rounded-lg z-50' onSubmit={handleFormSubmit}>
      <div className="flex items-center font-semibold text-xl gap-2">
        <img src={QuestionIcon} alt="Icon" />
        <p className='m-0'>Open Ended Question</p>
      </div>

      <div className="textArea-Size">
        <EquationEditor questionBody={questionBody} setQuestionBody={setQuestionBody} />
      </div>

      <div className="flex justify-end gap-2">
        <button onClick={handleCloseInnerModal} type="button" className="btn btn-secondary">Cancel</button>
        <button onClick={handleFormSubmit} type="submit" className="btn btn-primary active">Save </button>
      </div>
    </form>
  )
}
